<template>
  <div id="modal-login-offres">
    <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div v-if="forgotPassword" class="modal-content">
              <div class="modal-content-form">
                <div class="header-modal">
                  <h2 :class="isPhone ? 'merriweather-reg-28' : 'merriweather-reg-40'">Mot de passe oublié</h2>
                </div>
                <div v-if="sent" class="form-login raleway-reg-p15 align-items-center">
                  <div class="form-item">
                    <p>Nous venons d'envoyer un e-mail contenant des instructions ainsi qu'un lien pour réinitialiser votre mot de passe à l'adresse {{ this.forgotMail }}. Il est possible que vous deviez patienter quelques minutes avant de le recevoir.</p>
                  </div>
                  <button @click="goBack" class="hortense-btn-primary">Retour</button>
                </div>

                <div v-else class="form-login raleway-reg-p15 5 align-items-center">
                  <div class="form-item">
                    <label for="email">Saisissez votre adresse email</label>
                    <input v-model="forgotMail" type="text">
                  </div>
                  <button @click="sendForget" class="hortense-btn-primary">Envoyer le lien de réinitialisation</button>
                  <button @click="goBack" class="hortense-btn-secondary">Retour</button>
                </div>
              </div>
            </div>

            <div v-else class="modal-content">
              <div class="modal-content-form">
                <div class="header-modal">
                  <h2 :class="isPhone ? 'merriweather-reg-28' : 'merriweather-reg-40'">Accédez à votre espace membre</h2>
                </div>
                <div class="d-flex align-items-center pt-3" :class="isPhone ? 'flex-column' : ''">
                  <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/GIF+-+Page+offres+exclusives+-+Pop-up.gif" v-set-alt class="img-form-login">
                  <div class="form-login raleway-reg-p15 align-items-center" :class="isPhone ? 'pt-3' : 'pl-5'">
                    <p class="raleway-reg-p15 text-center mb-0">Connectez-vous pour retrouver vos offres et privilèges exclusifs.</p>
                    <div class="form-item">
                      <label for="email">E-mail</label>
                      <input v-model="userInfo.email" type="text">
                    </div>
                    <div class="form-item">
                      <label for="password">Mot de passe</label>
                      <input v-model="userInfo.password" type="password">
                    </div>
                    <p style='color: red;' class="mb-0" v-if='errorMessage'>Email ou mot de passe incorrect</p>
                  </div>
                </div>
                <div class="pt-4 d-flex flex-column align-items-center justify-content-center w-100 forgot-button">
                  <button @click="UserBasicInfo" class="hortense-btn-primary">ME CONNECTER</button>
                  <a style="cursor: pointer; line-height: 12px;" @click="showSignup" class="link-hortense mt-3">Créer un compte</a>
                  <a style="cursor: pointer" @click="forgotPassword = true" class="link-hortense">Mot de passe oublié?</a>
                </div>
                <div class="d-flex justify-content-center align-items-center home-button-login" @click="redirectTo('/')">
                  <i class="fa-solid fa-house ml-2" style="color: #3B6152;"></i>
                  <span class="raleway-reg-p15 ml-2 link-hortense cursor-pointer">Retour à la page d'accueil</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
  </div>
</template>

<script>
    import fetcher from 'packs/shared/api.js';

  export default{
    name: 'modal-login-offres',
    data() {
      return {
        userInfo: {
          email: '',
          password: ''
        },
        showModal: false,
        errorMessage: false,
        forgotPassword: false,
        forgotMail: '',
        sent: false,
        isPhone: window.innerWidth <= 768,
      };
    },
    beforeDestroy() {
      const whatsappBtn = document.getElementById('whatsapp-button');
      if (whatsappBtn) {
        whatsappBtn.style.display = 'block';
      }
      document.querySelectorAll('.fixed-banner').forEach(el => {
        el.style.zIndex = '';
      });
      document.querySelectorAll('.fixed-bannertwo').forEach(el => {
        el.style.zIndex = '';
      });
      if (this.isPhone) {
        document.body.style.overflow = '';
      }
    },
    mounted() {
      const whatsappBtn = document.getElementById('whatsapp-button');
      if (whatsappBtn) {
        whatsappBtn.style.display = 'none';
      }

      document.querySelectorAll('.fixed-banner').forEach(el => {
        el.style.zIndex = '1';
      });

      document.querySelectorAll('.fixed-bannertwo').forEach(el => {
        el.style.zIndex = '1';
      });

      if (this.isPhone) {
        document.body.style.overflow = 'hidden';
      }
    },
    methods: {
      redirectTo(path) {
        window.location.href = path;
      },
      pushLoginEvent(method) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'login',
          method: method,
        });
      },
      async UserBasicInfo(){
        try {
          const res = await fetcher.post('/users/sign_in', {
            user: {
              email: this.userInfo.email,
              password: this.userInfo.password,
              role: 'customer'
            }
          })
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'login',
            method: 'email_password',
          });
          if (res.data.redirect_to_otp) {
            window.location.href = '/user/otp';
          } else {
            this.$emit('close', res.data)
            location.reload();
          }
        } catch(e) {
          this.errorMessage = true;
        }
      },
      async sendForget(){
        try {
          const res = await fetcher.post('/send-reset-password', {
            email: this.forgotMail
          })
          console.log(res)
        } catch(e){
          console.log(e)
        }
        this.sent = true
      },
      goBack() {
        this.forgotPassword = false;
        this.sent = false;
        this.forgotMail = '';
      },
      showSignup() {
        this.$emit('showSignup');
      },
      setUser(user){
        this.user = user;
        this.showModal = false;
      },
    },
  }
</script>

<style lang="scss" scoped>
.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001 !important;
}

.modal-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.modal-content {
  background: #F4F4F4 0% 0% no-repeat padding-box;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  width: 90%;
  max-width: 1009px;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  @media screen and (min-width: 700px) {
    top: 5%;
  }
  @media screen and (max-width: 480px) {
    width: 100% !important;
    max-height: 95vh !important;
    height: 95vh !important;
    margin: 0;
    padding: 0;
  }
}

.modal-content-form {
  padding: 48px 75px;
  overflow-y: auto;
  
  @media screen and (max-width: 480px) {
    padding: 2rem 1rem;
    overflow-y: auto;
    overflow-x: hidden;
  }
}

.header-modal {
  text-align: center;
  margin-bottom: 2rem;

  h2 {
    margin: 0 0 0.5rem 0;
  }

  p {
    margin: 0;
  }

  @media screen and (max-width: 480px) {
    margin-bottom: 1.5rem;
  }
}

.form-login {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 100%;

  @media screen and (max-width: 480px) {
    gap: 1rem;
  }
}

.form-item {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  width: 100%;

  label {
    font-weight: 500;
    color: #333;
    font-size: 15px;
    margin-bottom: 0;
  }

  input {
    padding: 10px 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    font-family: 'Raleway', sans-serif;
    transition: border-color 0.3s ease;

    &:focus {
      outline: none;
      border-color: #3B6152;
    }

    &::placeholder {
      color: #999;
    }
  }

  p {
    margin: 0;
    line-height: 1.5;
  }
}

.forgot-button {
  .link-hortense {
    text-align: center;
    text-decoration: underline;
    cursor: pointer;
    font: normal normal normal 15px/48px Raleway;
    transition: all 0.3s ease;
    display: inline-block;

    &:hover {
      text-decoration: underline;
      color: black;
    }
  }
}

.home-button-login {
  .link-hortense {
    color: #3B6152;
    cursor: pointer;

    &:hover {
      color: #2d4a3d;
      text-decoration: underline;
    }
  }
}

.link-hortense {
  &:hover {
    text-decoration: underline;
  }
}

.mb-4 {
  margin-bottom: 1rem;
}

.signup-link {
  text-align: center;
  padding-top: 1.5rem;
  border-top: 1px solid #eee;
  margin-top: 1.5rem;
  padding-left: 2rem;
  padding-right: 2rem;
  padding-bottom: 1.5rem;

  p {
    margin: 0 0 0.5rem 0;
    color: #666;
    font-size: 14px;
  }

  .forgot-button {
    .link-hortense {
      color: #3B6152;
      text-decoration: underline;
      cursor: pointer;
      font-weight: 600;
      margin-bottom: 0;

      &:hover {
        color: #2d4a3d;
      }
    }
  }

  @media screen and (max-width: 480px) {
    margin-top: 1rem;
    padding-left: 1rem;
    padding-right: 1rem;
  }
}

.hortense-btn-secondary {
  background-color: transparent;
  color: #3B6152;
  border: 1px solid #3B6152;
  padding: 12px 24px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  width: auto;
  transition: all 0.3s ease;

  &:hover {
    background-color: #f5f5f5;
  }

  &:focus {
    outline: none;
  }
}

.modal-enter-active, .modal-leave-active {
  transition: opacity 0.3s ease;
}

.modal-enter, .modal-leave-to {
  opacity: 0;
}

.img-form-login {
  width: 382px;
  height: 323px;
  object-fit: cover;
  border-radius: 10px;

  @media screen and (max-width: 480px) {
    width: 100%;
    height: 323px;
  }
}
</style>
